import React from 'react';
import SalvPage from '../common/SalvPage';
import RerunScenariosCard from './scenario-rerun/RerunScenariosCard';
import FinalRiskRangeCard from './final-risk-range/FinalRiskRangeCard';
import { currentEnvironment, EnvironmentNames } from '../tracking/environment';

const environmentWarning = () => {
  const env = currentEnvironment();
  const prodEnvs = [EnvironmentNames.PRODUCTION, EnvironmentNames.LHV_UK, EnvironmentNames.LHV_EE];
  const demoEnvs = [EnvironmentNames.DEMO, EnvironmentNames.LHV_UK_UAT];
  if (env?.name && prodEnvs.includes(env.name)) {
    return (
      <div className='alert alert-danger' role='alert'>
        ⚠ You are on PRODUCTION. Changes here affect real data.
      </div>
    );
  }
  if (env?.name && demoEnvs.includes(env.name)) {
    return (
      <div className='alert alert-warning' role='alert'>
        ⚠ You are on the DEMO environment.
      </div>
    );
  }
  return null;
};

const EngineeringOps = () => {
  return (
    <SalvPage title='Engineering Ops'>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {environmentWarning()}
        <RerunScenariosCard />
        <FinalRiskRangeCard />
      </div>
    </SalvPage>
  );
};

export default EngineeringOps;
